import React from 'react';
import {
  Results,
  ResultsHeaderColumn,
  ResultsHeaderRow,
  ResultsTable,
  CheckBoxColumn,
  Checkbox,
} from './SearchResults.styles';
import {
  ResultRow,
  ResultsColumn,
} from '../../../NodeGroups/DTAccountSearch/Common/SearchResults/AccountSearchResultsList/AccountSearchResultsList.styles';
import { formatDateTime, priceFormat } from '../../../../../util';
import isEqual from 'lodash/isEqual';

const SearchResults = ({ results, onChange, selectedResult }) => {
  return (
    <Results key={'accountResults'}>
      <ResultsTable>
        <ResultsHeaderRow>
          <ResultsHeaderColumn>ITEM NAME</ResultsHeaderColumn>
          <ResultsHeaderColumn>QUANTITY</ResultsHeaderColumn>
          <ResultsHeaderColumn>AMOUNT</ResultsHeaderColumn>
          <ResultsHeaderColumn>DATE</ResultsHeaderColumn>
        </ResultsHeaderRow>
        {results.map((result, idx) => (
          <ResultRow key={`${result.itemId}_${idx}`}>
            <CheckBoxColumn>
              <Checkbox
                type={'checkbox'}
                onChange={() => onChange(result)}
                checked={isEqual(selectedResult, result)}
                data-testid={`checkbox-${result.itemId}`}
              />
            </CheckBoxColumn>
            <ResultsColumn width="25%">
              <span>{result.itemName}</span>
            </ResultsColumn>
            <ResultsColumn width="25%">
              <span>{result.itemQuantity}</span>
            </ResultsColumn>
            <ResultsColumn width="25%">
              <span>{priceFormat(result.paidAmount)}</span>
            </ResultsColumn>
            <ResultsColumn width="25%">
              <span>{formatDateTime(result.createdAt)}</span>
            </ResultsColumn>
          </ResultRow>
        ))}
      </ResultsTable>
    </Results>
  );
};

export default SearchResults;
